module.exports = __webpack_public_path__ + "static/media/Users 2.182a5757.svg";